import React, {FunctionComponent, memo} from "react";
import {Backdrop, Fade, Modal} from "@mui/material";
import styles from "./CustomModal.module.scss";
import CloseButton from "../../shared/ui/CloseButton/CloseButton";

export interface CustomModalPropsType {
    right?: boolean;
    children: React.ReactElement;
    isOpenModal: boolean;
    onCloseModalCallback: () => void;
    style?: React.CSSProperties;
    withCloseButton?: boolean
}

const CustomModal: FunctionComponent<CustomModalPropsType> = memo(
    ({children, isOpenModal, onCloseModalCallback, style, withCloseButton = true, ...props}) => {
        return (
            <Modal
                //FIXME устаревшие свойство, пока работает.
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 350,
                }}
                onClose={() => {
                    onCloseModalCallback();
                }}
                className={styles.modal}
                open={isOpenModal}
                {...props}
            >
                <Fade in={isOpenModal}>
                    <div style={style} className={styles.container}>
                        {withCloseButton &&
                            <CloseButton
                                onClick={() => {
                                    onCloseModalCallback();
                                }}
                            />
                        }
                        {children}
                    </div>
                </Fade>
            </Modal>
        );
    }
);

export default CustomModal;
